var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Scene"},[_c('canvas',{ref:"canvas",staticClass:"Scene-canvas",attrs:{"id":"renderCanvas","touch-action":"none","oncontextmenu":"return false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }